(ns ballot-scout-v2-frontend.layout.sidebar.views
  (:require
   [ballot-scout-v2-frontend.components.click-outside :refer [click-outside]]
   [ballot-scout-v2-frontend.components.icon :refer [icon] :as icon]
   [ballot-scout-v2-frontend.components.link :refer [href]]
   [ballot-scout-v2-frontend.events :as events]
   [ballot-scout-v2-frontend.layout.sidebar.views.election-switcher :as election-switcher]
   [ballot-scout-v2-frontend.layout.sidebar.views.jurisdiction-switcher :as jurisdiction-switcher]
   [ballot-scout-v2-frontend.layout.sidebar.views.partner-switcher :as partner-switcher]
   [ballot-scout-v2-frontend.subs :as subs]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(defn- menu-item
  "Clickable menu link with icon"
  [{:keys [icon-k heading route-name partner-slug jurisdiction-slug election-slug selected-routes]}]
  (let [current-route (rf/subscribe [:ballot-scout-v2-frontend.routes/current-route])]
    [:li
     [:a.menu-item {:href (href route-name {:partner-slug partner-slug
                                            :jurisdiction-slug jurisdiction-slug
                                            :election-slug election-slug})
                    :class (when (contains? selected-routes (get-in @current-route [:data :name])) "selected")}
      (if (some? icon-k)
        [:<> [icon icon-k] [:div.menu-heading heading]]
        [:div.menu-heading heading])]]))

(defn on-page? [selected-routes]
  (let [current-route @(rf/subscribe [:ballot-scout-v2-frontend.routes/current-route])]
    (contains? selected-routes (get-in current-route [:data :name]))))

(defn- sub-menu
  "Expandable dropdown sub-menu for the sidebar"
  [{:keys [selected-routes always-expanded?]}]
  (let [expanded-ratom (r/atom (on-page? selected-routes))]
    (fn [{:keys [id icon-k heading sub-menu-items selected-routes]}]
      (let [current-route @(rf/subscribe [:ballot-scout-v2-frontend.routes/current-route])
            expanded? (or always-expanded? (contains? selected-routes (get-in current-route [:data :name])) @expanded-ratom)]
        [click-outside
         {:on-click-outside #(reset! expanded-ratom false)}
         (fn [ref]
           [:li.sub-menu {:ref ref}
            [:a.menu-item {:id id
                           :class (when (on-page? selected-routes) "selected")
                           :on-click #(swap! expanded-ratom not)}
             [:<>
              [icon icon-k]
              [:div.menu-heading
               [:span {:class "menu-heading-text"} heading]
               (when (not always-expanded?)
                 [:span {:class "menu-expand-icon"}
                  (if expanded? [icon ::icon/chevron-up]
                      [icon ::icon/chevron-down])])]]]
            (when expanded?
              [:ul
               (into [:<>] sub-menu-items)])])]))))

(defn- sidebar-menu-items [{:keys [jurisdiction-slug partner-slug election-slug import-menu-expanded? disposition-menu-expanded?]}]
  (let [on-partner-admin-page @(rf/subscribe [::subs/on-partner-admin-page?])
        on-global-stats-page @(rf/subscribe [::subs/on-global-stats-page?])]
    (if (or on-partner-admin-page on-global-stats-page)
      [:<>
       [menu-item {:icon-k ::icon/home
                   :heading "Dashboard"
                   :route-name :ballot-scout-v2-frontend.routes/partner-home
                   :partner-slug partner-slug
                   :election-slug election-slug
                   :selected-routes #{:ballot-scout-v2-frontend.routes/partner-home}}]
       [menu-item {:icon-k ::icon/search
                   :heading "Voter Lookup"
                   :route-name :ballot-scout-v2-frontend.routes/partner-voter-lookup
                   :partner-slug partner-slug
                   :election-slug election-slug
                   :selected-routes #{:ballot-scout-v2-frontend.routes/partner-voter-lookup}}]
       [sub-menu {:id "dispositions-sub-menu"
                  :icon-k ::icon/check-to-slot
                  :heading "Import Disposition"
                  :selected-routes #{:ballot-scout-v2-frontend.routes/create-disposition-for-partner
                                     :ballot-scout-v2-frontend.routes/disposition-list-for-partner
                                     :ballot-scout-v2-frontend.routes/partner-disposition-manager}
                  :sub-menu-items
                  [[menu-item {:heading "New Disposition Import"
                               :route-name :ballot-scout-v2-frontend.routes/create-disposition-for-partner
                               :partner-slug partner-slug
                               :election-slug election-slug
                               :selected-routes #{:ballot-scout-v2-frontend.routes/create-disposition-for-partner}}]
                   [menu-item {:heading "Past Disposition Imports"
                               :route-name :ballot-scout-v2-frontend.routes/disposition-list-for-partner
                               :partner-slug partner-slug
                               :election-slug election-slug
                               :selected-routes #{:ballot-scout-v2-frontend.routes/disposition-list-for-partner}}]]
                  :always-expanded? disposition-menu-expanded?}]
       [menu-item {:icon-k ::icon/book
                   :heading "Guides and Resources"
                   :route-name :ballot-scout-v2-frontend.routes/partner-resources
                   :partner-slug partner-slug
                   :election-slug election-slug
                   :selected-routes #{:ballot-scout-v2-frontend.routes/partner-resources}}]
       (when @(rf/subscribe [::subs/admin?])
         [menu-item {:icon-k ::icon/chart-pie
                     :heading "Statistics"
                     :route-name :ballot-scout-v2-frontend.routes/global-stats
                     :partner-slug partner-slug
                     :selected-routes #{:ballot-scout-v2-frontend.routes/global-stats}}])]
      [:<>
       [menu-item {:icon-k ::icon/home
                   :heading "Dashboard"
                   :route-name :ballot-scout-v2-frontend.routes/jurisdiction-home
                   :partner-slug partner-slug
                   :jurisdiction-slug jurisdiction-slug
                   :election-slug election-slug
                   :selected-routes #{:ballot-scout-v2-frontend.routes/jurisdiction-home}}]
       [menu-item {:icon-k ::icon/search
                   :heading "Voter Lookup"
                   :route-name :ballot-scout-v2-frontend.routes/jurisdiction-voter-lookup
                   :partner-slug partner-slug
                   :jurisdiction-slug jurisdiction-slug
                   :election-slug election-slug
                   :selected-routes #{:ballot-scout-v2-frontend.routes/jurisdiction-voter-lookup}}]
       [sub-menu {:id "imports-sub-menu"
                  :icon-k ::icon/upload
                  :heading "Import Voters"
                  :selected-routes #{:ballot-scout-v2-frontend.routes/create-import
                                     :ballot-scout-v2-frontend.routes/import-list
                                     :ballot-scout-v2-frontend.routes/import-manager}
                  :sub-menu-items
                  [[menu-item {:heading "New Voter Import"
                               :route-name :ballot-scout-v2-frontend.routes/create-import
                               :partner-slug partner-slug
                               :jurisdiction-slug jurisdiction-slug
                               :election-slug election-slug
                               :selected-routes #{:ballot-scout-v2-frontend.routes/create-import}}]
                   [menu-item {:heading "Past Voter Imports"
                               :route-name :ballot-scout-v2-frontend.routes/import-list
                               :partner-slug partner-slug
                               :jurisdiction-slug jurisdiction-slug
                               :election-slug election-slug
                               :selected-routes #{:ballot-scout-v2-frontend.routes/import-list}}]]
                  :always-expanded? import-menu-expanded?}]
       [sub-menu {:id "dispositions-sub-menu"
                  :icon-k ::icon/check-to-slot
                  :heading "Import Disposition"
                  :selected-routes #{:ballot-scout-v2-frontend.routes/create-disposition-for-jurisdiction
                                     :ballot-scout-v2-frontend.routes/disposition-list-for-jurisdiction
                                     :ballot-scout-v2-frontend.routes/jurisdiction-disposition-manager}
                  :sub-menu-items
                  [[menu-item {:heading "New Disposition Import"
                               :route-name :ballot-scout-v2-frontend.routes/create-disposition-for-jurisdiction
                               :partner-slug partner-slug
                               :jurisdiction-slug jurisdiction-slug
                               :election-slug election-slug
                               :selected-routes #{:ballot-scout-v2-frontend.routes/create-disposition-for-jurisdiction}}]
                   [menu-item {:heading "Past Disposition Imports"
                               :route-name :ballot-scout-v2-frontend.routes/disposition-list-for-jurisdiction
                               :partner-slug partner-slug
                               :jurisdiction-slug jurisdiction-slug
                               :election-slug election-slug
                               :selected-routes #{:ballot-scout-v2-frontend.routes/disposition-list-for-jurisdiction}}]]
                  :always-expanded? disposition-menu-expanded?}]
       [menu-item {:icon-k ::icon/book
                   :heading "Guides and Resources"
                   :route-name :ballot-scout-v2-frontend.routes/resources
                   :partner-slug partner-slug
                   :jurisdiction-slug jurisdiction-slug
                   :election-slug election-slug
                   :selected-routes #{:ballot-scout-v2-frontend.routes/resources}}]
       (when @(rf/subscribe [::subs/admin?])
         [menu-item {:icon-k ::icon/chart-pie
                     :heading "Statistics"
                     :route-name :ballot-scout-v2-frontend.routes/global-stats
                     :partner-slug partner-slug
                     :selected-routes #{:ballot-scout-v2-frontend.routes/global-stats}}])])))

(defn- menu [params]
  [:aside.menu
   [:ul.menu-list
    [sidebar-menu-items params]]])

(defn- mobile-menu [params]
  [:aside.menu
   [:ul.menu-list
    [:li.sub-menu [jurisdiction-switcher/component]]
    (when (some? @(rf/subscribe [::subs/current-election]))
      [:li.sub-menu [election-switcher/component]])
    (when @(rf/subscribe [::subs/admin?])
      [:li.sub-menu [partner-switcher/component]])
    [sidebar-menu-items params]]])

(defn sidebar []
  (let [current-jurisdiction-slug @(rf/subscribe [::subs/current-jurisdiction-slug])
        current-election-slug @(rf/subscribe [::subs/election-slug-for-sidebar])
        current-partner-slug @(rf/subscribe [::subs/current-partner-slug])
        show-banner? @(rf/subscribe [::subs/show-banner?])]
    [:div {:class ["column" "is-2" "is-fullheight" "sidebar" "is-paddingless" "is-hidden-mobile" (if show-banner? "top-6" "top-4")]}
     [menu {:jurisdiction-slug current-jurisdiction-slug
            :election-slug current-election-slug
            :partner-slug current-partner-slug}]]))

(defn mobile-sidebar []
  (let [current-jurisdiction-slug @(rf/subscribe [::subs/current-jurisdiction-slug])
        current-election-slug @(rf/subscribe [::subs/election-slug-for-sidebar])
        current-partner-slug @(rf/subscribe [::subs/current-partner-slug])
        show-banner? @(rf/subscribe [::subs/show-banner?])]
    (when @(rf/subscribe [::subs/view-mobile-menu])
      [click-outside
       {:on-click-outside #(rf/dispatch [::events/set-view-mobile-menu false])}
       (fn [ref]
         [:div {:class ["column" "is-2 sidebar" "is-paddingless" "is-hidden-tablet" (if show-banner? "top-6" "top-4")]
                :ref ref}
          [mobile-menu {:jurisdiction-slug current-jurisdiction-slug
                        :election-slug current-election-slug
                        :partner-slug current-partner-slug
                        :import-menu-expanded? true
                        :disposition-menu-expanded? true}]])])))
